import { useState } from "react";
import { ShieldCheck, Calendar, Gavel, IdentificationCard, Percent, HardHat, CaretDown, CaretUp, ArrowsClockwise } from "@phosphor-icons/react";

export default function TermsAndConditions() {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (index) => {
    setOpenSection(openSection === index ? null : index);
  };

  const sections = [
    {
      title: "1. Natureza Jurídica e Escopo dos Serviços da Plataforma",
      icon: ShieldCheck,
      content: (
        <div className="space-y-3 text-justify">
          <p>
            <b>1.1. Provedor de Aplicação:</b> O AlugaJá, na qualidade de plataforma tecnológica digital, atua única e exclusivamente como provedor de aplicação de internet e hospedagem de anúncios, em estrita conformidade com o Artigo 14 da Lei nº 12.965/2014 (Marco Civil da Internet). 
          </p>
          <p>
            <b>1.2. Intermediação Pura:</b> Os Usuários declaram-se cientes de que a intermediação prestada pelo aplicativo restringe-se a aproximar de forma automatizada o proprietário/possuidor de um bem móvel (<b>Locador</b>) e o interessado em utilizá-lo temporariamente (<b>Locatário</b>). 
          </p>
          <p>
            <b>1.3. Ausência de Vínculo:</b> O AlugaJá não integra a cadeia de fornecimento dos produtos anunciados, não detém a posse, a propriedade, o gerenciamento físico, tampouco realiza vistoria prévia ou oferece qualquer modalidade de garantia (legal ou contratual) sobre os equipamentos listados por terceiros.
          </p>
        </div>
      ),
    },
    {
      title: "2. Cadastro de Usuários, Segurança e Tratamento de Dados (LGPD)",
      icon: IdentificationCard,
      content: (
        <div className="space-y-3 text-justify">
          <p>
            <b>2.1. Responsabilidade Civil Cadastral:</b> O Usuário assume total responsabilidade civil e criminal pela veracidade, exatidão e atualização dos dados declarados e documentos anexados. A inserção de dados falsos ou de terceiros ensejará a rescisão imediata do vínculo e comunicação às autoridades.
          </p>
          <p>
            <b>2.2. Consentimento e Compartilhamento de Dados (Art. 7º, V da LGPD):</b> Em cumprimento à Lei nº 13.709/2018 (Lei Geral de Proteção de Dados), o Usuário manifesta seu consentimento inequívoco para que o AlugaJá compartilhe seus dados pessoais (incluindo Nome Completo, CPF/CNPJ, Telefone, Endereço e Cópia de Documento de Identidade) com a contraparte da locação. Esse compartilhamento possui a finalidade estrita de permitir a conferência de identidade na entrega do bem e a execução do contrato de locação.
          </p>
          <p>
            <b>2.3. Cooperação Jurídica e Fornecimento de Logs:</b> Na ocorrência de disputas, inadimplemento culposo ou doloso, ou indícios de crimes (como apropriação indébita prevista no Art. 168 do Código Penal), o AlugaJá fornecerá formalmente o histórico de transações, logs de acesso, conversas e dossiê cadastral do Usuário infrator à parte prejudicada ou às autoridades policiais e judiciais competentes para fins de elaboração de Boletim de Ocorrência (BO) e instrução de medidas judiciais.
          </p>
        </div>
      ),
    },
    {
      title: "3. Modelo de Negócio, Remuneração e Alteração Unilateral de Taxas",
      icon: Percent,
      content: (
        <div className="space-y-3 text-justify">
          <p>
            <b>3.1. Remuneração dos Serviços de Intermediação:</b> Pela disponibilização do ecossistema tecnológico, gateway de pagamento e segurança da informação, serão aplicadas as seguintes tarifas operacionais de forma automatizada:
          </p>
          <ul className="list-disc pl-5 space-y-2 font-medium text-slate-800">
            <li>Tarifa do Locatário (Quem Aluga): R$ 0,50 (cinquenta centavos) de taxa fixa cobrada por transação financeira aprovada.</li>
            <li>Tarifa do Locador (Quem Postou): Retenção de 10% (dez por cento) sobre o valor bruto da locação OU o valor fixo mínimo de R$ 2,49 (dois reais e quarenta e nove centavos), prevalecendo SEMPRE o que for de maior valor.</li>
          </ul>
          <p>
            <b>3.2. Cláusula de Ajuste Unilateral Instantâneo:</b> O AlugaJá reserva-se o direito soberano de revisar, reajustar, extinguir ou instituir novas tarifas de serviço a qualquer momento, a seu exclusivo critério, visando preservar o equilíbrio econômico-financeiro da operação. Tais modificações passarão a vigorar imediatamente após sua inserção na plataforma para todas as novas reservas subsequentes, prescindindo de notificação prévia ou aviso individualizado aos Usuários.
          </p>
        </div>
      ),
    },
    {
      title: "4. Da Configuração Automática do Contrato de Locação e Parâmetro de Indenização",
      icon: Gavel,
      content: (
        <div className="space-y-3 text-justify">
          <p>
            <b>4.1. Contrato Eletrônico Interpartes:</b> Os Usuários declaram estar cientes de que a aprovação da reserva e a efetivação do pagamento caracterizam, por si sós, a celebração automática de um <b>Contrato de Locação de Coisas Móveis</b> diretamente entre o Locador e o Locatário, regido estritamente pelos Artigos 565 a 578 do Código Civil Brasileiro.
          </p>
          <p>
            <b>4.2. Parâmetro de Reparação Integral (Dano ou Extravio):</b> Na hipótese de o bem sofrer avaria severa por mau uso, quebra estrutural, perda, furto, roubo ou não devolução voluntária (apropriação indébita), as partes estabelecem contratualmente que a indenização material devida pelo Locatário ao Locador terá como parâmetro o <b>valor de mercado atualizado de um equipamento novo, de marca e modelo idênticos ou de características técnicas e mercadológicas estritamente semelhantes</b>, acrescido do valor de todas as diárias acumuladas até a efetiva quitação do débito.
          </p>
        </div>
      ),
    },
    {
      title: "5. Exclusão de Responsabilidade e Riscos Operacionais",
      icon: HardHat,
      content: (
        <div className="space-y-3 text-justify">
          <p>
            <b>5.1. Isenção sobre Danos Materiais e Execução:</b> O AlugaJá exime-se de qualquer responsabilidade civil ou indenizatória por perdas materiais, danos emergentes, lucros cessantes, deterioração, extravio ou vícios ocultos incidentes sobre os bens locados. A obrigação de entregar o item em perfeito estado de conservação e higienização é exclusiva do Locador.
          </p>
          <p>
            <b>5.2. Riscos por Acidentes e Manuseio:</b> A utilização, operação, guarda e transporte das ferramentas são de responsabilidade integral do Locatário. O AlugaJá não responde por acidentes de trabalho, danos a terceiros, lesões corporais ou prejuízos civis decorrentes do manuseio incorreto, imperícia ou falta de equipamentos de proteção individual (EPIs) por parte de quem alugou o maquinário.
          </p>
        </div>
      ),
    },
    {
      title: "6. Canal de Disputas, Prazo Decadencial e Foro de Eleição",
      icon: Calendar,
      content: (
        <div className="space-y-3 text-justify">
          <p>
            <b>6.1. Prazo Decadencial de Reclamação:</b> O Locatário dispõe do prazo preclusivo de <b>2 (duas) horas corridas</b>, contadas a partir do ato físico de recebimento/retirada do equipamento, para vistoriar o item e reportar formalmente ao suporte do AlugaJá qualquer vício, defeito mecânico ou desconformidade que impeça sua utilização ordinária. Transcorrido este prazo sem manifestação, presume-se de forma absoluta que o bem foi entregue em perfeitas condições de uso, não sendo aceitas reclamações posteriores para fins de estorno.
          </p>
          <p>
            <b>6.2. Sanções de Moderação Administrativa:</b> Independentemente das ações legais cíveis ou criminais cabíveis entre as partes, o AlugaJá poderá, discricionariamente, advertir, suspender temporariamente ou banir de forma definitiva o Usuário que apresentar condutas em desconformidade com a boa-fé objetiva, reincidência em disputas ou avaliações negativas sistemáticas.
          </p>
          <p>
            <b>6.3. Foro de Eleição:</b> Para dirimir quaisquer dúvidas ou controvérsias oriundas da utilização da plataforma ou da aplicação destes Termos, as partes elegem o <b>Foro da Comarca de Sorriso, Estado de Mato Grosso</b>, com expressa renúncia a qualquer outro, por mais privilegiado que seja.
          </p>
        </div>
      ),
    },
    {
      title: "7. Políticas de Cancelamento, Atrasos e Reembolsos",
      icon: ArrowsClockwise,
      content: (
        <div className="space-y-3 text-justify">
          <p>
            Para garantir uma experiência justa e segura para locatários e proprietários, o AlugaJá aplica as seguintes regras financeiras e de conduta:
          </p>
          <p><b>7.1. Atrasos e Não Comparecimento (No-Show):</b> Ao reservar um equipamento, ele fica bloqueado no sistema e indisponível para outras pessoas. Se você agendou uma retirada e não compareceu no horário:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>O seu tempo de locação começará a contar normalmente.</li>
            <li>Após 4 horas de atraso sem justificativa, o proprietário poderá cancelar a reserva alegando "Não comparecimento".</li>
            <li>Nesse caso, será cobrada 1 (uma) diária para indenizar o tempo em que a ferramenta ficou reservada. O valor restante (se houver) será estornado.</li>
            <li>Caso a retirada não ocorra, o sistema poderá cancelar automaticamente a reserva: em locações de até 2 dias, após 24 horas do horário agendado (cobrando 1 diária); em locações maiores, após 48 horas (cobrando 2 diárias).</li>
          </ul>
          <p><b>7.2. Cancelamento pelo Locatário (Arrependimento):</b> Alugou o equipamento errado ou mudou de ideia?</p>
          <ul className="list-disc pl-5 space-y-1">
            <li><b>Cancelamento Grátis:</b> você pode cancelar sem custos em até 30 minutos após a aprovação do proprietário, desde que falte mais de 2 horas para o horário agendado da retirada.</li>
            <li>Cancelamentos feitos fora dessa janela ou muito perto do horário de retirada estarão sujeitos a uma <b>taxa de quebra de reserva</b> (o maior valor entre um mínimo operacional e 20% do valor das diárias), sendo o restante estornado.</li>
          </ul>
          <p><b>7.3. Cancelamento pelo Proprietário (Falta de Estoque):</b> Proprietários devem manter seu catálogo sempre atualizado. Caso o proprietário cancele a reserva por não ter o item disponível:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>O Locatário receberá o reembolso integral e imediato, sem nenhuma taxa.</li>
            <li><b>Penalidade ao Proprietário:</b> o primeiro cancelamento por falta de estoque a cada 6 meses é isento. A partir do segundo, o proprietário será cobrado por uma multa operacional e pelas taxas de transação, que serão descontadas automaticamente do seu próximo repasse de locação.</li>
          </ul>
          <p><b>7.4. Regras de Reembolso:</b></p>
          <ul className="list-disc pl-5 space-y-1">
            <li><b>Pagamentos via PIX:</b> o valor estornado retornará automaticamente e de forma instantânea para a sua Carteira (Wallet) dentro do AlugaJá, podendo ser usado em novas locações.</li>
            <li><b>Pagamentos via Cartão de Crédito:</b> o estorno será processado diretamente para a administradora do cartão, podendo levar de 1 a 2 faturas para ser creditado, dependendo do seu banco.</li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <div className="max-w-3xl mx-auto px-4 py-6" data-testid="terms-page">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-heading font-bold text-[#004E98] mb-2">Termos de Uso e Regulamento Interno</h1>
        <p className="text-slate-600 text-sm max-w-md mx-auto">
          Este documento rege a utilização da plataforma AlugaJá e estabelece as obrigações e salvaguardas jurídicas recíprocas de nossa comunidade.
        </p>
      </div>

      <div className="space-y-3">
        {sections.map((section, index) => {
          const Icon = section.icon;
          const isOpen = openSection === index;

          return (
            <div key={index} className="aj-card overflow-hidden transition-all duration-200 border border-slate-100 bg-white shadow-sm rounded-xl">
              <button
                onClick={() => toggleSection(index)}
                className="w-full flex items-center justify-between p-4 text-left font-bold text-slate-800 hover:bg-slate-50 transition-colors"
                aria-expanded={isOpen}
              >
                <div className="flex items-center gap-3 text-sm sm:text-base">
                  <div className="p-2 rounded-lg bg-[#004E98]/10 text-[#004E98]">
                    <Icon size={20} weight="bold" />
                  </div>
                  {section.title}
                </div>
                {isOpen ? <CaretUp size={18} weight="bold" className="text-slate-400" /> : <CaretDown size={18} weight="bold" className="text-slate-400" />}
              </button>

              {isOpen && (
                <div className="px-6 pb-5 pt-3 border-t border-slate-50 text-slate-600 text-sm leading-relaxed bg-slate-50/50">
                  {section.content}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-8 text-center text-xs text-slate-400 font-medium">
        Última revisão e atualização jurídica: Junho de 2026. <br />
        AlugaJá Intermediação Digital Ltda. · Todos os direitos reservados.
      </div>
    </div>
  );
}